import { CancelToken } from "axios";
import { AdminType, APIGet, APIUrl } from "api/protocols";

interface IGetProcessingFees {
  id?: number;
}

export interface IPricingContext {
  payment_pricing_tier: string;
  label: string;
  description: string;
  fee_collection_note: string | null;
  shows_ic_plus_fee_breakdown: boolean;
  is_gross_settlement: boolean;
}

export async function GetProcessingFees(params: IGetProcessingFees, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/payment/processing-fee"), params, useGlobalLoader, token);
}

export async function GetMonthlyProcessingFeeSummary(
  params: { month: string },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/payment/processing-fee/monthly-summary"), params, useGlobalLoader, token);
}
